import { array, boolean, InferType, mixed, number, object, string } from "yup";
import { TContentType, TWritingType } from "./orders/order";
import { ThematicSchema } from "./Thematic";
import { TLangType } from "./LangType";

export const PosSchema = object({
    bl: number(),
    tf: string(),
    url: string(),
    words: number(),
    traffic: number(),
    da: number(),
});

export interface IVictoryKeyword {
    keyword: string;
    kd: number;
    volume: number;
}

export type TKeywordsList = "ranklvl1" | "ranklvl2" | "ranklvl3" | "aiAuto";

export const upsertKeywordMetrics = object({
    metrics: array().of(string()).min(1),
});

export const KeywordSchema = object({
    id: number().required(),
    lang: string<TLangType>().required(),
    keyword: string(),
    volume: number().nonNullable(),
    kd: number().nonNullable(),
    active: boolean()
        .transform((v1) => {
            return !!v1;
        })
        .required(),
    thematic: ThematicSchema.required(),
    pos2: PosSchema.nullable().transform((v1) => {
        if (v1) return JSON.parse(v1);
    }),
    pos4: PosSchema.nullable().transform((v1) => {
        if (v1) return JSON.parse(v1);
    }),
    pos6: PosSchema.nullable().transform((v1) => {
        if (v1) return JSON.parse(v1);
    }),
    pos8: PosSchema.nullable().transform((v1) => {
        if (v1) return JSON.parse(v1);
    }),
    pos10: PosSchema.nullable().transform((v1) => {
        if (v1) return JSON.parse(v1);
    }),
    pos11: PosSchema.nullable().transform((v1) => {
        if (v1) return JSON.parse(v1);
    }),
    pos12: PosSchema.nullable().transform((v1) => {
        if (v1) return JSON.parse(v1);
    }),
    pos14: PosSchema.nullable().transform((v1) => {
        if (v1) return JSON.parse(v1);
    }),
    pos15: PosSchema.nullable().transform((v1) => {
        if (v1) return JSON.parse(v1);
    }),
    pos18: PosSchema.nullable().transform((v1) => {
        if (v1) return JSON.parse(v1);
    }),
    pos20: PosSchema.nullable().transform((v1) => {
        if (v1) return JSON.parse(v1);
    }),
    pos23: PosSchema.nullable().transform((v1) => {
        if (v1) return JSON.parse(v1);
    }),
    pos25: PosSchema.nullable().transform((v1) => {
        if (v1) return JSON.parse(v1);
    }),
});

export const SimpleKeywordSchema = KeywordSchema.omit(["thematic"]).concat(
    object({
        thematic: string().required(),
    })
);

export const KeywordDTOSchema = object({
    keyword: string(),
    volume: number(),
    kd: number(),
});

export const KeywordsDTOSchema = object({
    thematicId: number().required(),
    lang: string<TLangType>().required().default("FR"),
    fileWithKeyword: mixed().required(),
});
export const KeywordsSchema = array(KeywordSchema);
export const SimpleKeywordsSchema = array(SimpleKeywordSchema);

export const UpsertKeywordOrderTextSchema = object({
    rdId: number().required(),
    writingType: string<TWritingType>()
        .required("error.order.writingType.required")
        .default("AI_AUTO"),
    contentType: string<TContentType>()
        .required("error.order.contentType.required")
        .default("BLOG"),
    wordCount: number().required("error.order.wordCount.required").default(1200),
});

export const upsertKeywordDTOSchema = object({
    id: number().required(),
    thematicId: number().required(),
});

export type Keyword = InferType<typeof KeywordSchema>;
export type UpsertKeywordOrderText = InferType<typeof UpsertKeywordOrderTextSchema>;
export type SimpleKeyword = InferType<typeof SimpleKeywordSchema>;
export type KeywordDTO = InferType<typeof KeywordDTOSchema>;
export type KeywordsDTO = InferType<typeof KeywordsDTOSchema>;
export type upsertKeywordDTO = InferType<typeof upsertKeywordDTOSchema>;
export type Pos = InferType<typeof PosSchema>;
